/**
 * Instagram Feed Component
 * Infinite scrolling animation (horizontal on desktop, vertical on mobile)
 */

class InstagramFeed {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-instagram-track]');
    this.content = section.querySelector('[data-instagram-content]');
    this.speed = parseFloat(this.track?.dataset.speed) || 3;

    if (this.track && this.content) {
      this.init();
    }
  }

  init() {
    this.calculateAnimationDuration();
    window.addEventListener('resize', () => this.handleResize());
  }

  handleResize() {
    this.calculateAnimationDuration();
  }

  calculateAnimationDuration() {
    // Horizontal scroll for all devices
    const contentWidth = this.content.offsetWidth;
    const baseDuration = contentWidth / 50; // Base speed
    const duration = baseDuration / this.speed;
    this.track.style.animationDuration = `${duration}s`;
  }

  destroy() {
    window.removeEventListener('resize', () => this.handleResize());
  }
}

function initInstagramFeeds() {
  const sections = document.querySelectorAll('[data-section-type="w-instagram-feed"]');
  sections.forEach(section => {
    if (!section.instagramFeedInstance) {
      section.instagramFeedInstance = new InstagramFeed(section);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initInstagramFeeds);
} else {
  initInstagramFeeds();
}

// Shopify theme editor support
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="w-instagram-feed"]');
    if (section) {
      section.instagramFeedInstance = new InstagramFeed(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-section-type="w-instagram-feed"]');
    if (section && section.instagramFeedInstance) {
      section.instagramFeedInstance.destroy();
      section.instagramFeedInstance = null;
    }
  });

  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('[data-section-type="w-instagram-feed"]');
    if (section && section.instagramFeedInstance) {
      section.instagramFeedInstance.calculateAnimationDuration();
    }
  });
}

// Expose class globally for dynamic initialization
window.InstagramFeed = InstagramFeed;
